<template>
    <div>
        <TransactionPage type="company" />
    </div>
</template>
  
<script>
import TransactionPage from '@/components/transaction/TransactionPage.vue';

export default {
    components: {
        TransactionPage
    }
};
</script>